import { render, staticRenderFns } from "./PublicDigitalAgreement.vue?vue&type=template&id=51b0b89f&scoped=true"
import script from "./PublicDigitalAgreement.vue?vue&type=script&lang=js"
export * from "./PublicDigitalAgreement.vue?vue&type=script&lang=js"
import style0 from "./PublicDigitalAgreement.vue?vue&type=style&index=0&id=51b0b89f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b0b89f",
  null
  
)

export default component.exports